import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
// import AdminBankinfo from "../components/AdminBankinfo";
import { Link } from "react-router-dom";
import AdminBankinfo from "./AdminBankinfo";
import ThemeSettings from "../../common/themeSettings/themeSettings";
import TransactionProof from "./transactionProof";
import { baseUrl } from "../../../enum/constant";
import axios from "axios";

const DashboardBuy = ({ status, trData }) => {
  const { from, amount, to, amountType, transactionType } = trData || {};
  // console.log("from", transactionType, from);
  const [cryptocurrencies, setCryptocurrencies] = useState([]);
  const [fiatCurrencies, setFiatCurrencies] = useState([]);
  const [cryptoSell, setCryptoSell] = useState("");
  const [cryptoBuy, setCryptoBuy] = useState("");
  const [currencySell, setCurrencySell] = useState("");
  const [currencyBuy, setCurrencyBuy] = useState("");
  const [cryptoAmountSell, setCryptoAmountSell] = useState(1);
  const [cryptoAmountBuy, setCryptoAmountBuy] = useState(1500);
  const [convertedAmountSell, setConvertedAmountSell] = useState("");
  const [convertedAmountBuy, setConvertedAmountBuy] = useState("");
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("buy");
  const [success, setSuccess] = React.useState("");
  const [error, setError] = React.useState("");
  const [recipientAddress, setRecipientAddress] = useState("");
  // const [status, setStatus] = useState("");
  const [selectedFiat, setSelectedFiat] = useState(null);
  const [selectedCryptoBuy1, setSelectedCryptoBuy1] = useState(null);
  const [selectedCryptoSell1, setSelectedCryptoSell1] = useState(null);
  const [copyMsg, setCopyMsg] = useState("");
  const [transationProof, setTransationProof] = useState(null);
  const [isBuyValid, setIsBuyValid] = useState(false);
  const sellWalletAdd = "TTtCDDFZeVT9w2VxaFeXvy5jX232d1RbUv";

  const [recipientValidationMessage, setRecipientValidationMessage] =
    useState("");
  const [showRecipientValidationMessage, setShowRecipientValidationMessage] =
    useState(false);

  const fiatLogos = {
    USD: "/images/currency/usd_90681e5a82.svg",
    EUR: "/images/currency/eur_2fb3ea3cae.svg",
  };

  const allowedFiats = Object.keys(fiatLogos);

  const cryptoSymbols = ["BTC", "USDT", "ETH", "USDC"]; // Filter only these symbols
  const navigate = useNavigate();
  const base = baseUrl;
  const cryptoUrl = base + "api/cryptos";
  const fiatUrl = base + "api/fiats";
  const conversionCryptoToFiatUrl = base + "api/convert";
  const conversionFiatToCryptoUrl = base + "api/convertfiat";

  const validateCustom = () => {
    const isChecked = document.getElementById("acceptterms")?.checked;
    if (recipientAddress && isChecked) {
      setIsBuyValid(true);
    } else {
      setIsBuyValid(false);
    }
  }

  useEffect(() => {
    validateCustom();
  }, [recipientAddress])


  const fetchData = async () => {
    try {
      const [cryptoResponse, fiatResponse] = await Promise.all([
        fetch(cryptoUrl),
        fetch(fiatUrl),
      ]);
      const cryptoData = await cryptoResponse.json();
      const fiatData = await fiatResponse.json();

      if (!cryptoData?.length) return;
      if (!fiatData?.length) return;

      // Filter only specific cryptocurrencies (BTC, USDT, ETH, USDC)
      const filteredCryptos =
        cryptoData?.filter((crypto) => cryptoSymbols.includes(crypto.symbol)) ||
        [];

      // Filter only USD and EUR from fiat currencies
      const filteredFiats =
        fiatData?.filter(
          (fiat) => fiat.symbol === "USD" || fiat.symbol === "EUR"
        ) || [];

      setCryptocurrencies(filteredCryptos);
      setFiatCurrencies(filteredFiats);

      if (from && transactionType) {
        const defaultCrypto = filteredCryptos?.find(
          (ele) => ele.symbol == from
        );
        const defaultCurrency = filteredFiats.find(
          (fiat) => fiat.symbol === to
        );

        setCryptoSell(defaultCrypto?.id);
        setCryptoBuy(defaultCrypto?.id);
        setCurrencySell(defaultCurrency?.id);
        setCurrencyBuy(defaultCurrency?.id);
        setSelectedCryptoBuy1(defaultCrypto);
        setSelectedCryptoSell1(defaultCrypto);
        setSelectedFiat(defaultCurrency);

        updateConversion(
          true,
          transactionType == "Sell" ? amount : 1,
          defaultCrypto?.symbol,
          defaultCurrency?.symbol
        );
        updateConversion(
          false,
          transactionType == "Sell" ? 1500 : amount,
          defaultCrypto?.symbol,
          defaultCurrency?.symbol
        );
      } else {
        const defaultCryptoId = filteredCryptos[0]?.id;
        const defaultCurrencyId =
          filteredFiats.find((fiat) => fiat.symbol === "USD")?.id ||
          filteredFiats[0]?.id;
        const defaultCurrency =
          filteredFiats.find((fiat) => fiat.symbol === "USD") ||
          filteredFiats[0];

        setCryptoSell(defaultCryptoId);
        setCryptoBuy(defaultCryptoId);
        setCurrencySell(defaultCurrencyId);
        setCurrencyBuy(defaultCurrencyId);
        setSelectedCryptoBuy1(filteredCryptos[0]);
        setSelectedCryptoSell1(filteredCryptos[0]);
        setSelectedFiat(
          filteredFiats.find((fiat) => fiat.symbol === "USD") ||
          filteredFiats[0]
        );

        updateConversion(
          true,
          1,
          filteredCryptos[0]?.symbol,
          defaultCurrency?.symbol
        );
        updateConversion(
          false,
          1500,
          filteredCryptos[0]?.symbol,
          defaultCurrency?.symbol
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const updateConversion = useCallback(
    async (isSell, amount, crypto, currency) => {
      const setConvertedAmount = isSell
        ? setConvertedAmountSell
        : setConvertedAmountBuy;
      let conversionUrl = isSell
        ? base + "api/convert-crypto-to-fiat"
        : base + "api/convert-fiat-to-crypto";

      try {
        if (!isSell) {
          setLoading(true);

          const fiat = currency || selectedFiat?.symbol;
          const crypto1 = crypto || selectedCryptoBuy1?.symbol;

          // Handle conversion from fiat to crypto
          const response = await axios.post(conversionUrl, {
            fiatSymbol: fiat,
            cryptoSymbol: crypto1,
            amount: amount,
          });

          setLoading(false);

          if (response.data && response.data.convertedAmount) {
            const convertedCryptoAmount =
              response.data.convertedAmount.toFixed(6);
            setConvertedAmount(convertedCryptoAmount);
          } else {
            setConvertedAmount("Conversion failed. Check inputs.");
          }
        } else {
          setLoading(true);

          const fiat = currency || selectedFiat?.symbol;
          const crypto1 = crypto || selectedCryptoSell1?.symbol;

          // Handle conversion from crypto to fiat

          const response = await axios.post(conversionUrl, {
            cryptoSymbol: crypto1,
            fiatSymbol: fiat,
            amount: amount,
          });

          setLoading(false);

          if (response.data && response.data.convertedAmount) {
            setConvertedAmount(response.data.convertedAmount.toFixed(2));
          } else {
            setConvertedAmount("Conversion failed. Check inputs.");
          }
        }
      } catch (error) {
        setConvertedAmount("Conversion error.");
        setLoading(false);
        console.error("Conversion error:", error);
      }
    },
    [cryptocurrencies, selectedCryptoSell1, selectedCryptoBuy1, selectedFiat]
  );

  // const updateConversionOld = useCallback(
  //   async (isSell, amount, cryptoId, currencyId) => {
  //     setLoading(true);

  //     const selectedCryptoId = cryptoId || (isSell ? cryptoSell : cryptoBuy);
  //     const selectedCurrencyId =
  //       currencyId || (isSell ? currencySell : currencyBuy);
  //     const conversionUrl = isSell
  //       ? conversionCryptoToFiatUrl
  //       : conversionFiatToCryptoUrl;
  //     const setConvertedAmount = isSell
  //       ? setConvertedAmountSell
  //       : setConvertedAmountBuy;

  //     if (
  //       !selectedCryptoId ||
  //       !selectedCurrencyId ||
  //       isNaN(amount) ||
  //       amount <= 0
  //     ) {
  //       setLoading(false);
  //       return;
  //     }

  //     try {
  //       const response = await fetch(conversionUrl, {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({
  //           cryptoId: selectedCryptoId,
  //           amount,
  //           currencyId: selectedCurrencyId,
  //           isCryptoToCurrency: isSell,
  //         }),
  //       });
  //       const data = await response.json();
  //       setLoading(false);

  //       if (data.convertedAmount) {
  //         const cryptoSymbol =
  //           cryptocurrencies.find((c) => c.id === selectedCryptoId)?.symbol ||
  //           "";

  //         setConvertedAmount(
  //           isSell
  //             ? `${data.currencySymbol || ""} ${data.convertedAmount}`
  //             : `${data.convertedAmount} ${cryptoSymbol}`
  //         );
  //       } else {
  //         setConvertedAmount("Conversion failed. Check inputs.");
  //       }
  //     } catch (error) {
  //       setConvertedAmount("Conversion error.");
  //       setLoading(false);
  //       console.error("Conversion error:", error);
  //     }
  //   },
  //   [cryptocurrencies, cryptoSell, cryptoBuy, currencySell, currencyBuy]
  // );

  useEffect(() => {
    fetchData();

    if (transactionType == "Sell") {
      const ele = document.getElementById("profile-tab");
      if (ele) {
        ele.click();
      }
    }
    if (amountType == "fiat") {
      setCryptoAmountBuy(amount);
    } else if (amountType == "crypto") {
      setCryptoAmountSell(amount);
    }
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (tab === "sell") {
      updateConversion(true, cryptoAmountSell);
    } else {
      updateConversion(false, cryptoAmountBuy);
    }
  };

  const validateWalletAddress = (add) => {
    // General regex for different wallet address formats
    const generalRegex =
      /^(1[a-km-zA-HJ-NP-Z1-9]{25,34}|3[a-km-zA-HJ-NP-Z1-9]{25,34}|[LM3][a-zA-HJ-NP-Z0-9]{26,33}|0x[a-fA-F0-9]{40}|[r][a-zA-Z0-9]{25,35})$/;

    // Check if the address matches the general format
    if (generalRegex.test(add)) {
      return "Valid crypto wallet address.";
    } else {
      return "Invalid wallet address.";
    }
  };

  // useEffect(() => {
  //   const usercrId = localStorage.getItem("userId");
  //   if (usercrId) {
  //     fetch(base + `api/current-status/${usercrId}`)
  //       .then((res) => res.json())
  //       .then((data) => {
  //         if (data.success) {
  //           setStatus(data.data.status); // "Approved", "Pending", etc.
  //         }
  //       })
  //       .catch((err) => {
  //         console.error("Error fetching verification status:", err);
  //       });
  //   }
  // }, []);

  const handleConfirm = (isSellBtn) => {
    // const {
    //   transactionId, userEmail, transaction_type, criptoname, currencyname, crypto_amount, converted_amount, wallet_address
    // } = { criptoname: "Eth" };
    // setTransationProof({
    //   transactionId, userEmail, transaction_type, criptoname, currencyname, crypto_amount, converted_amount, wallet_address
    // });
    // return;
    const isChecked = document.getElementById("acceptterms")?.checked;
    const token = localStorage.getItem("token");
    if (!token) {
      setError("You must be logged in to confirm an exchange..");
      setTimeout(() => {
        setError(""); // Clear the error after 3 seconds
      }, 3000);
      return;
    }

    if (!isChecked && !isSellBtn) {
      setError("You must accept the terms to proceed.");
      setTimeout(() => {
        setError(""); // Clear the error after 3 seconds
      }, 3000);
      return;
    }
    let recipientsAddress1;

    if (isSellBtn) {
      // setRecipientAddress(sellWalletAdd);
      recipientsAddress1 = sellWalletAdd;
    } else {
      recipientsAddress1 = recipientAddress;
    }

    if (status !== "Approved") {
      setError(
        "Your account is not approved yet. Please complete verification."
      );
      setTimeout(() => {
        setError(""); // Clear the error after 3 seconds
      }, 3000);
      return;
    }
    const validationMessage = validateWalletAddress(recipientsAddress1);
    setRecipientValidationMessage(validationMessage);
    setShowRecipientValidationMessage(true);

    if (!isSellBtn && !recipientsAddress1) {
      setError("Please enter wallet address.");
      setTimeout(() => {
        setError(""); // Clear the error after 3 seconds
      }, 3000);
      return;
    }
    // if (validationMessage.includes("Invalid") && !isSellBtn) {
    //   setError("Please enter a valid wallet address.");
    //   setTimeout(() => {
    //     setError(""); // Clear the error after 3 seconds
    //   }, 3000);
    //   return;
    // }

    const selectedCryptoSell = cryptocurrencies.find(
      (crypto) => crypto.id === parseInt(cryptoSell)
    );
    const selectedCryptoBuy = cryptocurrencies.find(
      (crypto) => crypto.id === parseInt(cryptoBuy)
    );
    const selectedCurrencySell = fiatCurrencies.find(
      (fiat) => fiat.id === parseInt(currencySell)
    );
    const selectedCurrencyBuy = fiatCurrencies.find(
      (fiat) => fiat.id === parseInt(currencyBuy)
    );

    const data = {
      cryptoSell: selectedCryptoSell?.name || "N/A",
      cryptoBuy: selectedCryptoBuy?.name || "N/A",
      currencySell: selectedCurrencySell?.name || "N/A",
      currencyBuy: selectedCurrencyBuy?.name || "N/A",
      cryptoAmountSell,
      cryptoAmountBuy,
      convertedAmountSell,
      convertedAmountBuy,
      recipientsAddress1,
    };

    let transactionData = {};

    if (isSellBtn && cryptoAmountSell > 0) {
      transactionData = {
        transactionType: "sell",
        cryptoName: selectedCryptoSell?.name,
        cryptoAmount: cryptoAmountSell,
        currencyName: selectedCurrencySell?.name,
        convertedAmount: convertedAmountSell,
        walletAddress: recipientsAddress1,
      };
    } else if (!isSellBtn && cryptoAmountBuy > 0) {
      transactionData = {
        transactionType: "buy",
        cryptoName: selectedCryptoBuy?.name,
        cryptoAmount: cryptoAmountBuy,
        currencyName: selectedCurrencyBuy?.name,
        convertedAmount: convertedAmountBuy,
        walletAddress: recipientsAddress1,
      };
    }

    if (Object.keys(transactionData).length > 0) {
      const Urldata = base + "api/buyselldata";
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      axios
        .post(Urldata, transactionData, {
          headers: headers,
        })
        .then((response) => response?.data)
        .then((result) => {
          console.log("result", result);
          if (result.message) {
            if (result.transactionId && result.userEmail) {
              const {
                transactionId,
                userEmail,
                transaction_type,
                criptoname,
                currencyname,
                crypto_amount,
                converted_amount,
                wallet_address,
              } = result;

              // Navigate to the new page with transactionId and userEmail via state
              // navigate("/Proof", {
              //   state: { transactionId, userEmail, transaction_type, criptoname, currencyname, crypto_amount, converted_amount, wallet_address },
              // });
              setTransationProof({
                transactionId,
                userEmail,
                transaction_type,
                criptoname,
                currencyname,
                crypto_amount,
                converted_amount,
                wallet_address,
              });
            }
          } else {
            setError(result.error || "An unknown error occurred.");
            setSuccess(""); // Clear any previous success message
          }
        })
        .catch((error) => {
          console.error("Error saving transaction data:", error);
          setError("An error occurred while processing the transaction.");
          setSuccess(""); // Clear success message if there's an error
        });
    }
  };

  const handleCopy = () => {
    if (sellWalletAdd) {
      try {
        navigator.clipboard.writeText(sellWalletAdd);
        setCopyMsg("Copied.");
        setTimeout(() => {
          setCopyMsg("");
        }, 3000);
      } catch (e) { }
    }
  };

  return (
    <>
      <div className="form-part">
        <div className="tab-part">
          <ul className="nav nav-tabs" id="myTab" role="tablist">
            <li className="nav-item" onClick={validateCustom}>
              <a
                className="nav-link active"
                id="home-tab"
                data-toggle="tab"
                href="#home"
                role="tab"
                aria-controls="home"
                aria-selected="true"
              >
                Buy
              </a>
            </li>
            <li className="nav-item" onClick={validateCustom}>
              <a
                className="nav-link"
                id="profile-tab"
                data-toggle="tab"
                href="#profile"
                role="tab"
                aria-controls="profile"
                aria-selected="false"
              >
                Sell
              </a>
            </li>
            <li className="nav-item last-setting">
              <a
                className="nav-link"
                id="setting-tab"
                data-toggle="tab"
                href="#setting"
                role="tab"
                aria-controls="profile"
                aria-selected="false"
              >
                <img src="assets/images/setting.png" />
              </a>
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="home"
              role="tabpanel"
              aria-labelledby="home-tab"
            >
              <div className="row">
                {transationProof?.transaction_type == "buy" ? (
                  <>
                    <TransactionProof transationProof={transationProof} />
                  </>
                ) : (
                  <div className="col-md-6 cus-col-6 pb-3">
                    <div className="crp-form px-0">
                      <h3>Buy crypto</h3>
                      <div className="fom-wrap">
                        <div className="fm-group">
                          <div className="field-bg">
                            <label>You Send</label>
                            <div className="p-2" style={{ display: "none" }}>
                              <p>
                                Selected value:{" "}
                                <strong id="selected-example">None</strong>
                              </p>
                            </div>
                            <div className="cpt-f-w">
                              {/* <!--========repeatable box=============!--> */}

                              <input
                                type="number"
                                placeholder="0.0"
                                className="c-inpt"
                                value={cryptoAmountBuy}
                                onChange={(e) => {
                                  setCryptoAmountBuy(e.target.value);
                                  updateConversion(false, e.target.value);
                                }}
                              />

                              <div className="sel-c">
                                <div
                                  className="dropdown sik-dropdown"
                                  id="sik-select"
                                >
                                  <button
                                    className="btn btn-secondary dropdown-toggle"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    id="dropdownButton2"
                                  >
                                    {selectedFiat ? (
                                      <>
                                        <img
                                          className="crypto-icon me-1"
                                          src={fiatLogos[selectedFiat.symbol]}
                                          alt={selectedFiat.symbol}
                                        />
                                        {selectedFiat.symbol}
                                      </>
                                    ) : (
                                      "Select"
                                    )}
                                  </button>
                                  <ul className="dropdown-menu dropdown-menu-dark buyget">
                                    {fiatCurrencies?.map((fiat) => (
                                      <li
                                        key={fiat.id}
                                        onClick={() => {
                                          setSelectedFiat(fiat);
                                          setCurrencyBuy(fiat.id);
                                          updateConversion(
                                            false,
                                            cryptoAmountBuy,
                                            selectedCryptoBuy1.symbol,
                                            fiat.symbol
                                          );
                                        }}
                                      >
                                        <span
                                          className={`dropdown-item ${selectedFiat?.id === fiat.id
                                            ? "active"
                                            : ""
                                            }`}
                                          data-value={fiat.id}
                                          data-image={fiatLogos[fiat.symbol]}
                                        >
                                          <img
                                            className="crypto-icon"
                                            src={fiatLogos[fiat.symbol]}
                                            alt={fiat.symbol}
                                          />
                                          {fiat.symbol}
                                        </span>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                                {/* <!--Custom select!--> */}
                              </div>
                              {/* <!--Custom select!--> */}
                            </div>
                            {/* <!--========repeatable box=============!--> */}
                          </div>
                        </div>

                        <div className="exchange-btn">
                          <Link to="#">
                            <img src="assets/images/exchange.png" />
                          </Link>
                        </div>

                        <div className="fm-group">
                          <div className="field-bg">
                            <label>You Get</label>
                            <div className="p-2" style={{ display: "none" }}>
                              <p>
                                Selected value:{" "}
                                <strong id="selected-example">None</strong>
                              </p>
                            </div>
                            <div className="cpt-f-w">
                              {/* <!--========repeatable box=============!--> */}

                              <input
                                type="text"
                                placeholder="0.0"
                                className="c-inpt"
                                value={
                                  loading
                                    ? "Loading..."
                                    : !isNaN(parseFloat(convertedAmountBuy))
                                      ? (() => {
                                        const amountOnly =
                                          parseFloat(convertedAmountBuy);
                                        const symbol =
                                          convertedAmountBuy.split(" ")[1] ||
                                          "";
                                        return `${amountOnly.toFixed(
                                          3
                                        )} ${symbol}`;
                                      })()
                                      : ""
                                }
                                readOnly
                              />

                              <div className="sel-c">
                                {/* <!--Custom select!--> */}
                                <div
                                  className="dropdown sik-dropdown"
                                  id="sik-select"
                                >
                                  <button
                                    className="btn btn-secondary dropdown-toggle"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    id="dropdownButton1"
                                  >
                                    {selectedCryptoBuy1 ? (
                                      <>
                                        <img
                                          className="crypto-icon me-1"
                                          src={selectedCryptoBuy1.logo}
                                          alt={selectedCryptoBuy1.symbol}
                                        />
                                        {selectedCryptoBuy1.symbol}
                                      </>
                                    ) : (
                                      "Select"
                                    )}
                                  </button>
                                  <ul className="dropdown-menu dropdown-menu-dark buysend">
                                    {cryptocurrencies?.map((crypto) => (
                                      <li
                                        key={crypto.id}
                                        onClick={() => {
                                          setSelectedCryptoBuy1(crypto);
                                          setCryptoBuy(crypto.id);
                                          updateConversion(
                                            false,
                                            cryptoAmountBuy,
                                            crypto.symbol,
                                            selectedFiat.symbol
                                          );
                                        }}
                                      >
                                        <span
                                          className={`dropdown-item ${selectedCryptoBuy1?.id === crypto.id
                                            ? "active"
                                            : ""
                                            }`}
                                          data-value={crypto.id}
                                          data-image={crypto.logo}
                                        >
                                          <img
                                            className="crypto-icon me-1"
                                            src={crypto.logo}
                                            alt={crypto.symbol}
                                          />
                                          {crypto.symbol}
                                        </span>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </div>
                              {/* <!--Custom select!--> */}
                            </div>
                            {/* <!--========repeatable box=============!--> */}
                          </div>
                        </div>

                        <div className="value">
                          {" "}
                          {cryptoAmountBuy} {selectedFiat?.symbol || "USD"} ≈{" "}
                          {isNaN(parseFloat(convertedAmountBuy))
                            ? ""
                            : parseFloat(convertedAmountBuy)?.toFixed(3)}{" "}
                          {selectedCryptoBuy1?.symbol || "ETH"}{" "}
                        </div>
                        {/* <!-- Value !--> */}
                        <div className="bottom-box-buy">
                          <h3>Recipient Wallet</h3>
                          <div className="field-bg">
                            <label for="">Wallet address</label>
                            <input
                              className="wallet-input"
                              type="text"
                              placeholder="0xABC123..."
                              name="Walletaddress"
                              onChange={(e) => {
                                setRecipientAddress(e.target.value);
                                setShowRecipientValidationMessage(false);
                              }}
                            />
                          </div>
                          {status === "Approved" && (
                            <div className="field-bg mt-3">
                              <label for="">Select Blockchain</label>
                              <input
                                className="wallet-input"
                                type="text"
                                placeholder="Blockchain"
                              />
                            </div>
                          )}
                          <label className="my-3">
                            <input
                              type="checkbox"
                              id="acceptterms"
                              name="acceptterms"
                              onChange={validateCustom}
                            />{" "}
                            I accept the <Link to="/terms-of-use">terms & conditions</Link>{" "}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="button-group">
                      <div>
                        {error && (
                          <div className="alert alert-danger text-center mb-3">
                            {error}
                          </div>
                        )}
                        {success && (
                          <div className="alert alert-success text-center mb-3">
                            {success}
                          </div>
                        )}
                      </div>
                      <Link
                        to="#"
                        className={`btn grey-btn ${isBuyValid ? 'btn-hovered' : ''}`}
                        onClick={() => handleConfirm(false)}
                      >
                        Buy{" "}
                        {selectedCryptoBuy1?.symbol
                          ? selectedCryptoBuy1.symbol
                          : "BTC"}
                      </Link>
                    </div>
                  </div>
                )}
                <AdminBankinfo
                  fiatSymbol={
                    fiatCurrencies.find(
                      (fiat) => fiat.id === parseInt(currencyBuy)
                    )?.symbol
                  }
                  activeTab={"buy"}
                />
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="profile"
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <div className="row">
                {transationProof?.transaction_type == "sell" ? (
                  <>
                    <TransactionProof transationProof={transationProof} />
                  </>
                ) : (
                  <div className="col-md-6 cus-col-6">
                    <div className="crp-form px-0">
                      <h3>Sell crypto</h3>
                      <div className="fom-wrap">
                        <div className="fm-group">
                          <div className="field-bg">
                            <label>You Send</label>
                            <div className="p-2" style={{ display: "none" }}>
                              <p>
                                Selected value:{" "}
                                <strong id="selected-example">None</strong>
                              </p>
                            </div>
                            <div className="cpt-f-w">
                              {/* <!--========repeatable box=============!--> */}

                              <input
                                type="number"
                                placeholder="0.0"
                                className="c-inpt"
                                value={cryptoAmountSell}
                                onChange={(e) => {
                                  setCryptoAmountSell(e.target.value);
                                  updateConversion(true, e.target.value);
                                }}
                              />

                              <div className="sel-c">
                                {/* <!--Custom select!--> */}
                                <div
                                  className="dropdown sik-dropdown"
                                  id="sik-select"
                                >
                                  <button
                                    className="btn btn-secondary dropdown-toggle"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    id="dropdownButton3"
                                  >
                                    {selectedCryptoSell1 ? (
                                      <>
                                        <img
                                          className="crypto-icon me-1"
                                          src={selectedCryptoSell1.logo}
                                          alt={selectedCryptoSell1.symbol}
                                        />
                                        {selectedCryptoSell1.symbol}
                                      </>
                                    ) : (
                                      "Select"
                                    )}
                                  </button>
                                  <ul className="dropdown-menu dropdown-menu-dark sellsend">
                                    {cryptocurrencies?.map((crypto) => (
                                      <li
                                        key={crypto.id}
                                        onClick={() => {
                                          setSelectedCryptoSell1(crypto);
                                          setCryptoSell(crypto.id);
                                          updateConversion(
                                            true,
                                            cryptoAmountSell,
                                            crypto.symbol,
                                            selectedFiat.symbol
                                          );
                                        }}
                                      >
                                        <span
                                          className={`dropdown-item ${selectedCryptoSell1?.id ===
                                            crypto.id
                                            ? "active"
                                            : ""
                                            }`}
                                          data-value={crypto.id}
                                          data-image={crypto.logo}
                                        >
                                          <img
                                            className="crypto-icon me-1"
                                            src={crypto.logo}
                                            alt={crypto.symbol}
                                          />
                                          {crypto.symbol}
                                        </span>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </div>
                              {/* <!--Custom select!--> */}
                            </div>
                            {/* <!--========repeatable box=============!--> */}
                          </div>
                        </div>

                        <div className="exchange-btn">
                          <Link to="#">
                            <img src="assets/images/exchange.png" />
                          </Link>
                        </div>

                        <div className="fm-group">
                          <div className="field-bg">
                            <label>You Get</label>
                            <div className="p-2" style={{ display: "none" }}>
                              <p>
                                Selected value:{" "}
                                <strong id="selected-example">None</strong>
                              </p>
                            </div>
                            <div className="cpt-f-w">
                              {/* <!--========repeatable box=============!--> */}

                              <input
                                type="text"
                                placeholder="0.0"
                                className="c-inpt"
                                value={
                                  loading
                                    ? "Loading..."
                                    : !isNaN(parseFloat(convertedAmountSell))
                                      ? (() => {
                                        const amountOnly =
                                          parseFloat(convertedAmountSell);
                                        const symbol =
                                          convertedAmountSell.split(" ")[1] ||
                                          "";
                                        return `${amountOnly.toFixed(
                                          3
                                        )} ${symbol}`;
                                      })()
                                      : ""
                                }
                                readOnly
                              />

                              <div className="sel-c">
                                {/* <!--Custom select!--> */}
                                <div
                                  className="dropdown sik-dropdown"
                                  id="sik-select"
                                >
                                  <button
                                    className="btn btn-secondary dropdown-toggle"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    id="dropdownButton4"
                                  >
                                    {selectedFiat ? (
                                      <>
                                        <img
                                          className="crypto-icon me-1"
                                          src={fiatLogos[selectedFiat.symbol]}
                                          alt={selectedFiat.symbol}
                                        />
                                        {selectedFiat.symbol}
                                      </>
                                    ) : (
                                      "Select"
                                    )}
                                  </button>
                                  <ul className="dropdown-menu dropdown-menu-dark sellget">
                                    {fiatCurrencies?.map((fiat) => (
                                      <li
                                        key={fiat.id}
                                        onClick={() => {
                                          setSelectedFiat(fiat);
                                          setCurrencyBuy(fiat.id);
                                          updateConversion(
                                            true,
                                            cryptoAmountSell,
                                            selectedCryptoBuy1.symbol,
                                            fiat.symbol
                                          );
                                        }}
                                      >
                                        <span
                                          className={`dropdown-item ${selectedFiat?.id === fiat.id
                                            ? "active"
                                            : ""
                                            }`}
                                          data-value={fiat.id}
                                          data-image={fiatLogos[fiat.symbol]}
                                        >
                                          <img
                                            className="crypto-icon"
                                            src={fiatLogos[fiat.symbol]}
                                            alt={fiat.symbol}
                                          />
                                          {fiat.symbol}
                                        </span>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </div>
                              {/* <!--Custom select!--> */}
                            </div>
                            {/* <!--========repeatable box=============!--> */}
                          </div>
                        </div>

                        <div className="value">
                          {" "}
                          {cryptoAmountSell}{" "}
                          {selectedCryptoSell1?.symbol || "ETH"} ≈{" "}
                          {isNaN(parseFloat(convertedAmountSell))
                            ? ""
                            : parseFloat(convertedAmountSell)?.toFixed(3)}{" "}
                          {selectedFiat?.symbol || "USD"}{" "}
                        </div>
                        {/* <!-- Value !--> */}

                        {/* <div className="btn-part">
																			<a href="" className="btn buy-btn">Sell ETH</a>
																		</div> */}
                        <div>
                          {error && (
                            <div className="alert alert-danger text-center mb-3">
                              {error}
                            </div>
                          )}
                          {success && (
                            <div className="alert alert-success text-center mb-3">
                              {success}
                            </div>
                          )}
                        </div>
                        <div className="button-group">
                          <Link
                            to="#"
                            className="btn grey-btn btn-hovered"
                            onClick={() => handleConfirm(true)}
                          >
                            Sell{" "}
                            {selectedCryptoSell1?.symbol
                              ? selectedCryptoSell1?.symbol
                              : "BTC"}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="col-md-6">
                  <div className="inner-box">
                    <h3>Wallet details</h3>

                    <div className="warning-box">
                      <img src="assets/images/warning-icon.png" />
                      <p>
                        Only send Ethereum (ERC-20) assets to this address.
                        Other assets will be lost forever.
                      </p>
                    </div>
                    <div className="qr-box">
                      <h5>
                        <img src="assets/images/ETH.png" /> Ethereum (ERC-20)
                      </h5>
                      <div className="qr-inner">
                        <img src="assets/images/qr.png" />
                        <p>{sellWalletAdd}</p>
                        <p className="text-success">{copyMsg}</p>
                        <a
                          href="#"
                          className="btn btn-qr"
                          onClick={(e) => {
                            e.preventDefault();
                            handleCopy();
                          }}
                        >
                          Copy wallet address
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="setting"
              role="tabpanel"
              aria-labelledby="setting-tab"
            >
              <ThemeSettings />
            </div>
          </div>
        </div>
      </div>

      <div className="info-box-bottom px-3">
        <h2>Useful Tips to Know</h2>
        <p>We will process your transaction even if you:</p>
        <ul>
          <li>
            Send a deposit in the wrong network, if this asset is supported by
            our service
          </li>
          <li>Create a transaction with the wrong coin</li>
          <li>Select an amount and then send a different one</li>
          <li>Send more than one deposit for the same transaction</li>
          <li>
            Send a deposit long after the exchange was created or completed
          </li>
        </ul>
        <p>
          We will not be able to proceed with the transaction on the initial
          terms if you:
        </p>
        <ul>
          <li>
            Send a deposit for a fixed-rate exchange after the rate expires,
            provided the rate declines over this timeframe
          </li>
          <li>Make a transaction using the wrong contract address</li>
        </ul>
      </div>
      <div className="cta-box text-center">
        <h5>
          In these cases, we encourage you to contact our support team.
          <br />
          The exchange can be continued from there, or alternatively,
          <br />
          you are free to request a refund.
        </h5>
        <Link to="/contact-us" className="btn btn-cta">
          Contact Support
        </Link>
      </div>

      <div className="info-box-bottom px-3">
        <h2>How to Cancel an Exchange:</h2>

        <ul>
          <li>
            If you didn’t send any funds yet, there is no need to cancel the
            transaction; you can simply create a new one.
          </li>
          <li>
            If you have already sent the funds for the exchange, immediately
            contact our support team for assistance.
          </li>
        </ul>
      </div>
    </>
  );
};

export default DashboardBuy;
